document.addEventListener('DOMContentLoaded', function () {
  redrawAllHeroImages();
});
window.addEventListener('resize', function () {
  redrawAllHeroImages();
});
const redrawAllHeroImages = () => {
  const screenwidth = window.innerWidth;

  const homeHeroV2s = document.querySelectorAll('.home-heroV2.calculateJS');
  homeHeroV2s.forEach((homeHeroV2) => {
    const images = homeHeroV2.querySelectorAll('.imageWrappInner img');
    const videos = homeHeroV2.querySelectorAll('video');

    const widthss = [];
    const onschreen = [];
    images.forEach((image) => {
      image.style.width = 'auto';
      // get width of image
      const imageWidth = image.offsetWidth;

      if (imageWidth) {
        widthss.push(imageWidth);
        onschreen.push(image);
      }
    });
    videos.forEach((video) => {
      video.style.width = 'auto';
      // get width of video
      const videoWidth = video.offsetWidth;

      if (videoWidth) {
        widthss.push(videoWidth);
        onschreen.push(video);
      }
    });

    const smallestWidth = Math.min(...widthss);
    console.log(screenwidth);
    if (screenwidth > 900) {
      onschreen.forEach((element) => {
        element.style.width = smallestWidth + 'px';
        if (element.parentElement?.nextElementSibling?.classList.contains('moro-logo')) {
          // set width of moro-logo to smallestWidth
          element.parentElement.nextElementSibling.style.left = smallestWidth / 2 + 'px';
          element.parentElement.nextElementSibling.style.maxWidth = smallestWidth + 'px';
        }
      });
    } else {
      onschreen.forEach((element) => {
        element.style.width = '100%';
      });
    }

    homeHeroV2.querySelectorAll('.moro-logo').forEach((logo) => {
      logo.style.opacity = 1;
    });

    images.forEach((image) => {
      image.style.opacity = 1;
    });
    videos.forEach((video) => {
      video.style.opacity = 1;
    });
  });
};

// check if user is on ipad
const isIpad = navigator.userAgent.match(/iPad/i) != null;
const isIpadPro = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
if (isIpad || isIpadPro) {
  document.body.classList.add('forceMobileNavigation');
}

// get the href=#chat link and add event listener onclick to it to onclick="GorgiasChat.open();
const chatLinks = document.querySelectorAll('a[href="#chat"]');
Array.from(chatLinks).forEach(function (chatLink) {
  chatLink.addEventListener('click', function (e) {
    e.preventDefault();
    GorgiasChat.open();
  });
});

const chatCloseButton = document.querySelector('.morobe-close-button');
if (chatCloseButton) {
  chatCloseButton.addEventListener('click', function (e) {
    e.preventDefault();
    GorgiasChat.close();
  });
}

var initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve();
      });
    });

initGorgiasChatPromise.then(function () {
  GorgiasChat.on('widget:closed', function () {
    document.body.classList.remove('gorgias-chat-open');
  });

  GorgiasChat.on('widget:opened', function () {
    document.body.classList.add('gorgias-chat-open');
  });
});

// get width of sidebar and set css variable --morobe-nav-width to it
const sidebar = document.querySelector('#morobe-menu');
if (sidebar) {
  // add 10px for hover effect
  const sidebarWidth = sidebar.offsetWidth + 10;

  // document.documentElement.style.setProperty('--morobe-nav-width', sidebarWidth + 'px');
}

class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.content');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();

    // check if there is an other details element open
    const details = document.querySelectorAll('main details');
    Array.from(details).forEach((el) => {
      if (el !== this.el && el.open) {
        el.open = false;
      }
    });
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    // set a max of 200 for the scrollable content
    const newEndHeight = Math.min(this.summary.offsetHeight + this.content.offsetHeight, 200);
    const endHeight = `${newEndHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('main details').forEach((el) => {
  new Accordion(el);
});

document.addEventListener('DOMContentLoaded', function () {
  const heelTypeFilter = document.querySelector('#filter-heel-type');
  if (heelTypeFilter) {
    // set in this order: Flat, Mid heel, High heel
    const ul = heelTypeFilter;
    const li = ul.querySelectorAll('li');
    const liArray = Array.from(li);
    ul.innerHTML = '';
    const newLiArray = [];
    liArray.forEach((li) => {
      if (li.textContent.includes('Flat')) {
        newLiArray[0] = li;
      } else if (li.textContent.includes('Mid')) {
        newLiArray[1] = li;
      } else if (li.textContent.includes('High')) {
        newLiArray[2] = li;
      }
    });
    newLiArray.forEach((li) => {
      ul.appendChild(li);
    });
  }

  const heelHeightFilter = document.querySelector('#filter-heel-height-mm');

  if (heelHeightFilter) {
    // reverse the li items inside the ul
    const ul = heelHeightFilter;
    const li = ul.querySelectorAll('li');
    const liArray = Array.from(li);
    ul.innerHTML = '';
    liArray
      .sort((a, b) => (parseInt(a.textContent) < parseInt(b.textContent) ? -1 : 1))
      .forEach((li) => {
        ul.appendChild(li);
      });
  }

  const sizesFilter = document.querySelector('#filter-maat');

  if (sizesFilter) {
    const ul = sizesFilter;
    const li = ul.querySelectorAll('li');
    const liArray = Array.from(li);
    ul.innerHTML = '';
    liArray
      .sort((a, b) =>
        parseInt(a.textContent.replace('1/2', ',5')) < parseInt(b.textContent.replace('1/2', ',5')) ? -1 : 1
      )
      .forEach((li) => {
        ul.appendChild(li);
      });
  }

  const colorsFilter = document.querySelector('#filter-color');
  if (colorsFilter) {
    const ul = colorsFilter;
    const li = ul.querySelectorAll('li');
    const liArray = Array.from(li);
    ul.innerHTML = '';
    liArray
      .sort((a, b) => {
        // compare data-color-hex attributes

        return (a.dataset.colorHex || '').localeCompare(b.dataset.colorHex);
      })
      .reverse()
      .forEach((li) => {
        ul.appendChild(li);
      });
  }
});
